import React from "react";
import './Card.css';

const Card = ({ image, title, description, link }) => {
  return (
    <div className="Card">
      <img src={image} alt={title} className="cardImage" />
      <div className="cardContent">
        <h3 className="cardTitle">{title}</h3>
        <p className="cardDescription">{description}</p>
        <a href={link} className="cardLink">
            <u> Read more</u>
        </a>
      </div>
    </div>
  );
};

export default Card;
